import { useIsPage } from '@/features/shared/hooks/useIsPage'
import { type BadgeType } from '@/features/shared/elements/Badges/types'
import { type Product } from '@/features/shop/services/Product/types'

export const useGetProductFlag = (
  product: Pick<Product, 'oos' | 'bought' | 'lowStock' | 'for_you'>,
  limit?: number,
): BadgeType | undefined => {
  const isBuyAgainPage = useIsPage().BUY_AGAIN

  if (limit) {
    return 'limit'
  } else if (product.oos) {
    return 'oos'
  } else if (product.bought && !isBuyAgainPage) {
    return 'buyAgain'
  } else if (product.lowStock) {
    return 'lowStock'
  } else if (product.for_you) {
    return 'forYou'
  }
}
